import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioChurchRerpot, ClergyBioRoutes, DataState } from '../model/clergy-bio-app-models';
import ClergyBioComponentLoader from '../components/clergy-bio-component-loader';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { personInfoSelfDescribeValue } from '../../../global/validation-schemas/account-information-form-validation';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { LabelAndValue } from '../../../global/components/data-display/label-value';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';


interface Props {
	settings: ClergyBioSettings;
	basePath: string;
}

function ClergyBioChurchReportingReview(props: Props) {

	const { settings, basePath } = props;
	const loadingState = useSelector<TcsmStates, DataState>(state => state?.clergyBioState?.loaded?.churchReport);
	const churchReport = useSelector<TcsmStates, ClergyBioChurchRerpot>(state => state?.clergyBioState?.churchReport);
	const buttonClasses = buttonStyles();

	function RenderValues(list: string[], specify: string) {
		return list?.concat([specify])?.filter(a => a && a !== personInfoSelfDescribeValue).join(', ');
	}

	function RenderContent() {
		return (
			<>
				<h3>{settings?.churchReportingSubTitle}</h3>
				<ContentSpacer>
					<WysiwygWithReactLink content={settings?.churchReportingDescription} />
				</ContentSpacer>
				<LabelAndValue label={settings?.raceLabel} value={RenderValues(churchReport?.details?.ethnicities, churchReport?.details?.ethnicitySpecify)} />
				<></>
				<></>
				<LabelAndValue label={settings?.genderIdentityLabel} value={RenderValues(churchReport?.details?.genderIdentities, churchReport?.details?.genderSpecify)} />
				<LabelAndValue label={settings?.sexualOrientationLabel} value={RenderValues(churchReport?.details?.sexualOrientations, churchReport?.details?.sexualSpecify)} />
			</>
		);
	}

	return (
		<DividerSection removeDivider greySection sectionText={settings?.churchReportingTitle} >
			<ClergyBioComponentLoader
				state={loadingState}
				content={<RenderContent />}
			/>
			<ContentSpacer>
				<Link className={buttonClasses.primaryButton} to={`${basePath}${ClergyBioRoutes.ChurchReporting}`}>{settings?.updateButtonText}</Link>
			</ContentSpacer>
		</DividerSection>
	);
}


export default ClergyBioChurchReportingReview;